module.exports = __webpack_public_path__ + "img/LTS_NT.80d7eaed.gif";